import Vue from 'vue'
import auth from '@websanova/vue-auth/dist/v2/vue-auth.common.js'
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.js'
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js'
import store from '@/store'

Vue.use(auth, {
  plugins: {
    http: Vue.axios,
    router: Vue.router
  },
  drivers: {
    auth: {
      request: function (req, token) {
        this.drivers.http.setHeaders.call(this, req, {
          Authorization: 'Bearer ' + token
        })
        Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      },
      response: function (res) {
        return res.data.token
      }
    },
    http: driverHttpAxios,
    router: driverRouterVueRouter
  },
  options: {
    rolesKey: 'type',
    notFoundRedirect: { name: 'user-account' },
    fetchUser: true,
    authRedirect: { path: '/signin' },
    loginData: { url: '/auth', fetchUser: true },
    fetchData: { url: '/api/v1/user-profile', enabled: true },
    refreshData: { url: '/auth/refresh', enabled: false },
    staySignedIn: true,
    parseUserData(data) {
      store.commit('user/setUserData', data)
      return data || {}
    }
  }
})
